<template>
  <div id="_contacts">
    <div class="contacts-container">
      <div class="contact-header">
        <div class="contact-search">
          <el-input :placeholder="$t('search_contacts')" v-model="searchTerm" @clear="searchTerm = null" clearable=""> <i slot="prefix" class="el-input__icon el-icon-search"></i> </el-input>
        </div>
      </div>

      <Nodata :title="$t('nodatakeys.contacts.nodatatitle')" :description="$t('nodatakeys.contacts.nodatadesc')" anim="holacon-contacts-lottie" :loading="loading" v-if="participants.length == 0 && (searchTerm == null || searchTerm == '')" :button="$t('nodatakeys.contacts.nodatabutton')" @btnClick="getData()" />

      <Nodata
        :title="$t('nodatakeys.contacts.nofilterdatatitle')"
        :description="$t('nodatakeys.contacts.nofilterdatadesc')"
        anim="holacon-contacts-lottie"
        :loading="loading"
        v-if="participants.length == 0 && searchTerm != null && searchTerm != ''"
        :button="$t('nodatakeys.contacts.nofilterdatabutton')"
        @btnClick="
          searchTerm = null;
          getData();
        "
      />

      <div class="contacts-list">
        <div class="contact-item" v-for="item in participants" :key="item.id">
          <div class="contact-avatar" @click="$root.$emit('getProfile', item.id)" :style="'background-image: url(' + $imageus + item.image + '?width=150&height=150&mode=cover);'"></div>
          <div class="contact-title" @click="$root.$emit('getProfile', item.id)">
            <div class="contact-title-fullname">
              {{ item.fullName }}
            </div>
            <div class="contact-title-title" v-if="item.contactInfo.title != null">
              <span v-if="item.contactInfo.title != null || item.contactInfo.title != ''"> {{ item.contactInfo.title }}</span>
              <span v-if="item.contactInfo.company != null || item.contactInfo.company != ''">@{{ item.contactInfo.company }}</span>
            </div>
          </div>
          <div class="contact-operations">
            <el-popconfirm :confirm-button-text="$t('notify_confirm')" :cancel-button-text="$t('notify_cancel')" icon="el-icon-info" icon-color="red" @confirm="unfollow(item)" :title="$t('contacts_remove')">
              <el-button type="danger" slot="reference" icon="fas fa-user-times" circle size="mini" style="height:31px;"></el-button>
            </el-popconfirm>
            <!-- <md-button class="md-icon-button md-raised invite-button" @click="unfollow(item)">
              <i class="fa fa-user-times"></i>
            </md-button> -->
          </div>
        </div>
      </div>

      <infinite-loading :infinite-scroll-listen-for-event="true" @infinite="getData">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "Contacts",
  components: { InfiniteLoading },
  props: ["showInvite"],
  data() {
    return {
      participants: [],
      timeout: null,
      searchTerm: null,
      loading: false,
      item: null
    };
  },
  methods: {
    getData($state, reset) {
      this.loading = true;
      axios
        .post("account/getfollowings", {
          skip: reset ? 0 : this.participants.length,
          take: 20,
          searchTerm: this.searchTerm != "" ? this.searchTerm : null
        })
        .then(response => {
          if (response.data.data.items == null) {
            response.data.data.items = [];
          }
          if (reset) {
            this.participants = response.data.data.items;
          } else {
            this.participants = [...this.participants, ...response.data.data.items];
          }

          this.loading = false;

          if (response.data.data.items.length == 0) $state.complete();
          else $state.loaded();
        });
    },
    async unfollow(item) {
      var res = await axios.post("profile/changefollow", {
        userID: item.id,
        follow: false
      });
      if (res.data.hasError) {
        this.$message({
          type: "error",
          message: res.data.message
        });
      } else {
        var index = this.participants.findIndex(k => k.id == item.id);
        if (index != -1) {
          this.participants.splice(index, 1);
        }
        this.$message({
          type: "success",
          message: res.data.message
        });
      }
    }
  },
  watch: {
    searchTerm: function() {
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = null;
      this.timeout = setTimeout(() => {
        this.getData(null, true);
      }, 300);
    }
  }
};
</script>

<style lang="less">
#_contacts {
  display: flex;
  flex-direction: column;
  width: 100%;

  .contacts-container {
    display: block;
    width: inherit;
    margin: 0 auto;

    .contact-header {
      margin-bottom: 20px;
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;

      .contact-search {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        position: relative;
      }
    }

    .contacts-list {
      width: 100%;
      padding: 10px;
      .contact-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: #e8ebef;
        padding: 10px;
        border-radius: 12px;
        margin-bottom: 10px;

        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }

        .contact-avatar {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          background-size: cover;
          border-radius: 50%;
          border: 2px solid #fff;
          cursor: pointer;
        }

        .contact-title {
          display: flex;
          flex-direction: column;
          margin-left: 12px;
          flex-grow: 1;
          cursor: pointer;
          .contact-title-fullname {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: #292f3b;
          }
          .contact-title-title {
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #505763;
          }
        }
        .contact-operations {
          flex-shrink: 0;
          display: block;

          .invite-button {
            box-shadow: unset;

            i {
              color: #8c929c;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #_contacts {
    padding: 4px;

    .contacts-container {
      padding: 0px 12px;

      .contact-header {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Contacts.vue